import { Empty } from 'antd';

export default function NoRecord() {
    return (
        <div className="!my-6 !ml-4 !mr-6 !rounded bg-white !h-[calc(100vh-120px)] overflow-y-auto overflow-x-auto custom-scroll !w-full grid place-items-center">
            <Empty description="No policy history records found" />
        </div>
    );
}
